import * as Sentry from "@sentry/react";

import { supabase } from "../../data/supabase/client";
import { logError } from "../../utils/error";
import { CountMessageTokensParams, TokenCountResult } from "./types";

// Token counting function that returns a Result type
export const countMessageTokens = async (
  params: CountMessageTokensParams
): Promise<TokenCountResult> => {
  try {
    const { context, query = "", systemPrompt, model } = params;

    const { data, error } = await supabase.functions.invoke("claude-count-tokens", {
      body: {
        systemPrompt,
        context,
        query,
        model
      }
    });

    if (error) {
      return {
        ok: false,
        error: new Error(error.message || "Failed to count tokens")
      };
    }

    return {
      ok: true,
      tokenCount: data.tokenCount
    };
  } catch (error) {
    logError("Error counting tokens", error);
    Sentry.captureException(error, {
      tags: {
        function: "countMessageTokens",
        module: "claude-query"
      },
      extra: {
        hasContext: !!params.context,
        model: params.model
      }
    });
    return {
      ok: false,
      error: error instanceof Error ? error : new Error("An unknown error occurred")
    };
  }
};
